import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=58733672&scoped=true"
import script from "./HowItWorks.vue?vue&type=script&lang=js"
export * from "./HowItWorks.vue?vue&type=script&lang=js"
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=58733672&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58733672",
  null
  
)

export default component.exports